import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#2563eb',
          secondary: '#dbeafe',
          accent: '#1d4ed8',
          error: '#dc2626',
          info: '#0891b2',
          success: '#16a34a',
          warning: '#f59e0b'
        }
      }
    }
  },
  defaults: {
    VSnackbar: {
      timeout: 3000,
      color: 'white',
      elevation: 8
    }
  },
  icons: {
    defaultSet: 'mdi'
  }
})
